<template>
  <Layout :is-loading="isLoading" :can-cancel="false">
    <div class="bloco">
      <header>
        <HeaderPage :page-titles="pageTitles" :hide-button="true" />
        <div class="row-option">
          <b-form-group
            class="col-lg-6 col-md-12"
            label="Empresa"
            label-for="input-1"
            :description="descriptionEmpresa"
          >
            <b-form-select
              v-model="empresa"
              :options="optionsEmpresas"
              @change="handleChangeSelectEmpresa"
            />
          </b-form-group>
          <b-form-group
            class="col-lg-6 col-md-12"
            label="Filial"
            label-for="input-1"
            :description="descriptionFilial"
          >
            <b-form-select
              v-model="filial"
              :disabled="empresa === null"
              :options="optionsFiliais"
              @change="handleChangeSelectFilial"
            />
          </b-form-group>
        </div>
        <hr />
      </header>
      <section>
        <div class="row">
          <b-card class="col-lg-6 col-md-12" title="Usuários ativos e inativos">
            <apexchart
              class="chart"
              fore-color="#000"
              :series="
                optionsUsuariosAtivosInativos.series
                  ? optionsUsuariosAtivosInativos.series
                  : []
              "
              :options="optionsUsuariosAtivosInativos"
            />
            <div class="text-width">
              <img
                src="../../../../assets/images/rotate.svg"
                style="height: 120px"
              />
              <p>
                A tela de seu dispositivo é muito pequena para exibir este
                gráfico, tente alternar a orientação do dispositivo para
                horizontal.
              </p>
            </div>
          </b-card>
          <b-card
            class="col-lg-6 col-md-12"
            title="Acessos de usuários por Sistema"
          >
            <apexchart
              class="chart"
              fore-color="#000"
              :series="
                optionsUsuariosSistema.series
                  ? optionsUsuariosSistema.series
                  : []
              "
              :options="optionsUsuariosSistema"
            />
            <div class="text-width">
              <img
                src="../../../../assets/images/rotate.svg"
                style="height: 120px"
              />
              <p>
                A tela de seu dispositivo é muito pequena para exibir este
                gráfico, tente alternar a orientação do dispositivo para
                horizontal.
              </p>
            </div>
          </b-card>
        </div>
        <div class="row">
          <b-card
            class="col-lg-6 col-md-12"
            title="Total de usuários cadastrados"
          >
            <apexchart
              v-if="optionsUsuariosCadastrados.xaxis.categories.length > 0"
              class="chart"
              fore-color="#000"
              :series="usuariosCadastrados ? usuariosCadastrados : []"
              :options="optionsUsuariosCadastrados"
            />
            <div class="text-width">
              <img
                src="../../../../assets/images/rotate.svg"
                style="height: 120px"
              />
              <p>
                A tela de seu dispositivo é muito pequena para exibir este
                gráfico, tente alternar a orientação do dispositivo para
                horizontal.
              </p>
            </div>
          </b-card>
          <b-card class="col-lg-6 col-md-12" title="Opções">
            <div class="container-buttons">
              <button class="button-box" @click="showModalUsers = true">
                <feather type="users" />
                Listar usuários cadastrados
              </button>
              <button
                class="button-box"
                @click="showModalUsersInactives = true"
              >
                <feather type="user-x" />
                Listar usuários inativos
              </button>
            </div>
          </b-card>
        </div>
      </section>

      <b-modal
        v-model="showModalUsersInactives"
        title="Lista de Usuários Inativos"
        size="xl"
        hide-footer
      >
        <b-table
          ref="tableUsersInactives"
          striped
          :items="
            usuariosAtivosInativos.usersInactives
              ? usuariosAtivosInativos.usersInactives
              : []
          "
          :fields="usuariosFields"
          per-page="10"
          :current-page="currentPageUsuariosInativos"
          empty-text="Não há usuários inativos."
          show-empty
          responsive
        />

        <div class="container-pagination">
          <b-pagination
            v-model="currentPageUsuariosInativos"
            :total-rows="
              usuariosAtivosInativos.usersInactives.length > 0
                ? usuariosAtivosInativos.usersInactives.length
                : 0
            "
            per-page="10"
            aria-controls="tableUsersInactives"
          />
        </div>
      </b-modal>

      <b-modal
        v-model="showModalUsers"
        title="Lista de Usuários"
        size="xl"
        hide-footer
      >
        <b-table
          ref="tableUsersInactives"
          striped
          :items="usuarios ? usuarios : []"
          :fields="usuariosFields"
          per-page="10"
          :current-page="currentPageUsuarios"
          empty-text="Não há usuários cadastrados."
          show-empty
          responsive
        />

        <div class="container-pagination">
          <b-pagination
            v-model="currentPageUsuarios"
            :total-rows="usuarios.length ? usuarios.length : 0"
            per-page="10"
            aria-controls="tableUsersInactives"
          />
        </div>
      </b-modal>
    </div>
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'
import alertMixin from '@/src/mixins/alertMixin'
import 'vue-select/dist/vue-select.css'
import serviceStatistics from '@/src/services/serviceStatistics'
import serviceEmpresas from '@/src/services/serviceEmpresaObra'
import serviceFiliais from '@/src/services/serviceFilialObra'
import serviceUsuarioObra from '@/src/services/serviceUsuarioObra'

export default {
  components: { Layout, HeaderPage },
  mixins: [alertMixin],
  data() {
    return {
      isLoading: false,
      empresa: null,
      optionsEmpresas: [{ value: null, text: 'Todas' }],
      descriptionEmpresa:
        'Ao não selecionar uma empresa, serão exibidas as estatísticas referentes a todas as empresas.',
      filial: null,
      optionsFiliais: [{ value: null, text: 'Todas' }],
      descriptionFilial: 'Selecione uma empresa para exibir as filiais.',
      nomeEmpresa: '',

      // Variáveis relativas a modais
      showModalUsersInactives: false,
      showModalUsers: false,

      // variáveis relativas a páginação de usuários
      currentPageUsuarios: 1,

      // variáveis relativas a páginação de usuários inativos
      currentPageUsuariosInativos: 1,

      // variáveis relativas a tabela de usuários
      usuarios: [],

      // variável relativa aos fields de tabelas
      usuariosFields: [
        {
          label: 'Nome',
          key: 'nome',
          sortable: true,
        },
        {
          label: 'E-mail',
          key: 'email',
          sortable: true,
          thStyle: { width: '25vw' },
        },
        {
          label: 'Função',
          key: 'funcao',
          sortable: true,
          thStyle: { width: '20vw' },
        },
      ],

      // Variáveis relativas ao gráfico de usuários cadastrados
      optionsUsuariosCadastrados: {
        chart: {
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        yaxis: {
          show: false,
        },
        xaxis: {
          categories: [],
          labels: {
            show: true,
            style: {
              fontSize: '14px',
            },
          },
        },
      },

      usuariosCadastrados: [
        {
          name: 'Usuários',
          foreColor: '#000',
          data: [],
        },
      ],

      // Variáveis relativas ao gráfico de usuários ativos e inativos
      usuariosAtivosInativos: {},
      optionsUsuariosAtivosInativos: {
        chart: {
          type: 'pie',
        },
        labels: ['Usuários ativos', 'Usuários inativos'],
        fontSize: 14,
        series: [],
      },

      // Variáveis relativas ao gráfico de usuários por sistema
      optionsUsuariosSistema: {
        chart: {
          type: 'pie',
        },
        fontSize: 14,
        labels: ['Usuários Web', 'Usuários Web Mobile', 'Usuários APP'],
        series: [],
      },

      // Variáveis relativas ao pageHeader
      pageTitles: {
        title: 'Estatísticas de Usuários',
        subtitle: 'Estatísticas sobre usuários do CFObras',
      },
    }
  },

  async mounted() {
    this.isLoading = true
    await Promise.all([
      this.getUsuariosCadastrados(),
      this.getUsuariosAtivosInativos(),
      this.getEmpresas(),
      this.getUsuariosSistema(),
      this.getUsuarios(),
    ])
    this.isLoading = false
  },
  methods: {
    // Função relativa ao gráfico de usuários cadastrados
    async getUsuariosCadastrados() {
      try {
        const response = await serviceStatistics.getUsers(
          this.empresa,
          this.filial
        )
        let usuarios = response.data
        let data = {
          series: [
            {
              name: 'Usuários cadastrados',
              foreColor: '#000',
              data: [],
            },
            {
              name: 'Usuários deletados',
              foreColor: '#000',
              data: [],
            },
          ],
        }

        for (const mes in usuarios.usuarios) {
          this.optionsUsuariosCadastrados.xaxis.categories.push(mes)
          data.series[0].data.push(usuarios.usuarios[mes])
          data.series[1].data.push(usuarios.deletados[mes])
        }

        this.usuariosCadastrados = data.series
      } catch (error) {
        this.$store.commit('SET_ERROR', error)
      }
    },

    // Função relativa ao gráfico de usuários por sistema
    async getUsuariosSistema() {
      try {
        const response = await serviceStatistics.getSystems(
          this.empresa,
          this.filial
        )

        this.optionsUsuariosSistema.series = []
        this.optionsUsuariosSistema.series.push(response.data.webComputer)
        this.optionsUsuariosSistema.series.push(response.data.webMobile)
        this.optionsUsuariosSistema.series.push(response.data.app)
      } catch (error) {
        this.$bvToast.toast(
          'Ocorreu um erro ao carregar os dados, tente novamente.',
          {
            variant: 'danger',
            autoHideDelay: 5000,
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
      }
    },

    // Função relativa ao gráfico de usuários ativos e inativos
    async getUsuariosAtivosInativos() {
      try {
        const response = await serviceStatistics.getUsersActive(
          this.empresa,
          this.filial
        )

        this.usuariosAtivosInativos = response.data
        this.optionsUsuariosAtivosInativos.series.push(
          this.usuariosAtivosInativos.totalUsersActives
        )
        this.optionsUsuariosAtivosInativos.series.push(
          this.usuariosAtivosInativos.totalUsers
        )
      } catch (error) {
        this.$bvToast.toast(
          'Ocorreu um erro ao carregar os dados, tente novamente.',
          {
            variant: 'danger',
            autoHideDelay: 5000,
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
      }
    },

    // função para obter os usuários
    async getUsuarios() {
      try {
        await serviceUsuarioObra
          .listAll(this.empresa, this.filial)
          .then((response) => {
            this.usuarios = response.data.data
          })
      } catch (_e) {
        this.$bvToast.toast(
          'Ocorreu um erro ao carregar os dados, tente novamente.',
          {
            variant: 'danger',
            autoHideDelay: 5000,
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
      }
    },

    // Função para obter as empresas
    async getEmpresas() {
      let { data } = await serviceEmpresas.listEmpresas()

      data.map((empresa) => {
        this.optionsEmpresas.push({
          value: empresa._id,
          text: empresa.nome,
        })
      })
    },

    // Função relativa ao select de filial
    handleChangeSelectFilial() {
      this.reloading()

      if (this.filial) {
        const filial = this.optionsFiliais.find(
          (filial) => filial.value === this.filial
        )
        this.nomeFilial = filial.text
      }

      if (!this.filial && !this.empresa) {
        this.descriptionFilial = 'Selecione uma empresa para exibir as filiais.'
      } else if (!this.filial) {
        this.descriptionFilial = `Selecione uma filial para refinar os resultados da empresa: ${this.nomeEmpresa}`
      } else {
        this.descriptionFilial = `Exibindo estatísticas da filial: ${this.nomeFilial}`
      }
    },

    // Função relativa ao select de empresa
    async handleChangeSelectEmpresa() {
      this.filial = null

      this.reloading()

      if (this.empresa) {
        const empresa = this.optionsEmpresas.find(
          (empresa) => empresa.value === this.empresa
        )
        this.nomeEmpresa = empresa.text

        this.optionsFiliais = [{ value: null, text: 'Todas' }]

        await serviceFiliais.listByEmpresa(this.empresa).then((filiais) => {
          filiais.data.map((filial) => {
            this.optionsFiliais.push({
              value: filial._id,
              text: filial.nome,
            })
          })
        })
      }

      if (!this.empresa) {
        this.descriptionEmpresa =
          'Ao não selecionar uma empresa, serão exibidas as estatísticas referentes a todas as empresas.'
        this.filial = null
        this.descriptionFilial = 'Selecione uma empresa para exibir as filiais.'
      } else {
        this.descriptionEmpresa = `Exibindo estatísticas da empresa: ${this.nomeEmpresa}`
        this.descriptionFilial = `Selecione uma filial para refinar os resultados da empresa: ${this.nomeEmpresa}`
      }
    },

    // função para recarregar os dados
    async reloading() {
      this.isLoading = true
      this.currentPageUsuariosInativos = 1
      this.rowsUsuariosInativos = 0

      this.currentPageUsuarios = 1
      this.rowsUsuarios = 0

      this.optionsUsuariosAtivosInativos.series = []
      this.usuariosCadastrados = []

      await Promise.all([
        this.getUsuariosCadastrados(),
        this.getUsuariosAtivosInativos(),
        this.getUsuariosSistema(),
        this.getUsuarios(),
      ])
      this.isLoading = false
    },
  },
}
</script>

<style>
.row-option {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}

.button-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  gap: 10px;
  height: 150px;
  width: 150px;
  cursor: pointer;
}

.button-box:hover {
  background-color: rgb(0 143 251);
  color: #fff;
  transition: all 0.3s ease-in-out;
}

.container-buttons {
  display: flex;
  height: 85%;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
  gap: 10px;
}

.container-pagination {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.chart {
  display: block;
}

.text-width {
  display: none;
}

@media (max-width: 465px) {
  .chart {
    display: none;
  }

  .text-width {
    display: flex;
    flex-direction: column;
    text-align: justify;
    font-weight: bold;
    gap: 30px;
    margin-top: 25px;
  }

  .text-width img {
    margin-top: 15px;
    margin-bottom: 15px;
  }
}

@media (max-width: 1300px) {
  .row-option {
    flex-direction: column;
  }
}
</style>


<style src="../style.scss" lang="scss"></style>
